import request from '@/utils/request'

// 查询用户预约记录列表
export function listChannelUser(query) {
    return request({
        url: '/biz/channelUser/list',
        method: 'get',
        params: query
    })
}

// 查询用户预约记录列表
export function listTodayChannelUser(query) {
    return request({
        url: '/biz/channelUser/listToday',
        method: 'get',
        params: query
    })
}

// 查询用户预约记录详细
export function getChannelUser(id) {
    return request({
        url: '/biz/channelUser/' + id,
        method: 'get'
    })
}

// 新增用户预约记录
export function addChannelUser(data) {
    return request({
        url: '/biz/channelUser/update',
        method: 'post',
        data: data
    })
}

// 修改用户预约记录
export function updateChannelUser(data) {
    return request({
        url: '/biz/channelUser/update',
        method: 'post',
        data: data
    })
}

export function editWriteOff(data) {
    return request({
        url: '/biz/channelUser/editWriteOff',
        method: 'post',
        data: data
    })
}


// 取消用户预约记录
export function delChannelUser(id) {
    return request({
        url: '/biz/channelUser/delete/' + id,
        method: 'post'
    })
}

export function cancelChannelUser(data) {
    return request({
        url: '/biz/channelUser/cancel',
        method: 'post',
        data: data
    })
}
